import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import dayOfYear from "dayjs/plugin/dayOfYear";
import quarterOfYear from "dayjs/plugin/quarterOfYear";
dayjs.extend(dayOfYear);
dayjs.extend(quarterOfYear);
dayjs.extend(customParseFormat);
import { getLocale } from "./locale";
const YMD_FORMATS = [
  "YYYYMMDD",
  "YYYY-MM-DD",
  "YYYY/M/D",
  "YYYY/MM/D",
  "YYYY/MM/DD",
  "YYYY/M/DD",
  "YY/M/D",
  "YY/MM/D",
  "YY/MM/DD",
  "YY/M/DD",
  "YYYY.M.D",
  "YYYY.MM.D",
  "YYYY.MM.DD",
  "YYYY.M.DD",
  "YY.M.D",
  "YY.MM.D",
  "YY.MM.DD",
  "YY.M.DD",
  "YYYY-M-D",
  "YYYY-MM-D",
  "YYYY-M-DD",
  "YY-M-D",
  "YY-MM-D",
  "YY-MM-DD",
  "YY-M-DD"
];
const MDY_FORMATS = [
  "YYYYMMDD",
  "YYYY-MM-DD",
  "M/D/YYYY",
  "MM/D/YYYY",
  "MM/DD/YYYY",
  "M/DD/YYYY",
  "M/D/YY",
  "MM/D/YY",
  "MM/DD/YY",
  "M/DD/YY",
  "M.D.YYYY",
  "MM.D.YYYY",
  "MM.DD.YYYY",
  "M.DD.YYYY",
  "M.D.YY",
  "MM.D.YY",
  "MM.DD.YY",
  "M.DD.YY",
  "M-D-YYYY",
  "MM-D-YYYY",
  "MM-DD-YYYY",
  "M-DD-YYYY",
  "M-D-YY",
  "MM-D-YY",
  "MM-DD-YY",
  "M-DD-YY"
];
const DMY_FORMATS = [
  "YYYYMMDD",
  "YYYY-MM-DD",
  "D/M/YYYY",
  "D/MM/YYYY",
  "DD/MM/YYYY",
  "DD/M/YYYY",
  "D/M/YY",
  "D/MM/YY",
  "DD/MM/YY",
  "DD/M/YY",
  "D.M.YYYY",
  "D.MM.YYYY",
  "DD.MM.YYYY",
  "DD.M.YYYY",
  "D.M.YY",
  "D.MM.YY",
  "DD.MM.YY",
  "DD.M.YY",
  "D-M-YYYY",
  "D-MM-YYYY",
  "DD-MM-YYYY",
  "DD-M-YYYY",
  "D-M-YY",
  "D-MM-YY",
  "DD-MM-YY",
  "DD-M-YY"
];
const PARSE_FORMATS = {
  "YYYY[-]MM[-]DD": YMD_FORMATS,
  "YYYY[.]MM[.]DD": YMD_FORMATS,
  "YYYY[/]MM[/]DD": YMD_FORMATS,
  "MM[/]DD[/]YYYY": MDY_FORMATS,
  "DD[/]MM[/]YYYY": DMY_FORMATS,
  "DD[.]MM[.]YYYY": DMY_FORMATS
};
export function parse(value, strict = false) {
  const formats = PARSE_FORMATS[getLocale().date_format];
  return dayjs(value, formats, strict);
}
export function localize(date) {
  if (date == null)
    return "";
  return dayjs(date).format(getLocale().date_format);
}
export function parse_localized(str) {
  const formats = getLocale().date_format.match(/\w+/g);
  const parts = str.match(/\d+/g);
  if (parts.length !== formats.length) {
    return new Date();
  }
  let year, month, day;
  for (let i = 0; i <= 2; i++) {
    const part = parseInt(parts[i], 10);
    switch (formats[i]) {
      case "YYYY":
        year = part;
        if (year < 100) {
          year += 2e3;
        } else if (year < 1e3) {
          year = new Date().getFullYear();
        }
        break;
      case "MM":
        month = part;
        break;
      case "DD":
        day = part;
    }
  }
  return new Date(year, month - 1, day);
}
export function format_timeframe(start, end) {
  const same_year = start.getFullYear() === end.getFullYear();
  const same_month = start.getMonth() === end.getMonth();
  const date_format = same_year && same_month ? "day" : same_year ? "day_month" : "human_format";
  const prefix = format(start, date_format);
  return dayjs(end).format(`[${prefix} \u2013 ]DD[ ]MMM[ ]YYYY`);
}
export function first_day_of_week(date) {
  date = dst_safe_date(date);
  const day = date.getDay();
  let diff = getLocale().week_start_day - day;
  if (diff > 0) {
    diff -= 7;
  }
  date.setDate(date.getDate() + diff);
  return date;
}
export function first_day_of_semimonth(date) {
  date = dst_safe_date(date);
  if (date.getDate() < 16) {
    date.setDate(1);
  } else {
    date.setDate(16);
  }
  return date;
}
export function first_day_of_month(date) {
  date = dst_safe_date(date);
  date.setDate(1);
  return date;
}
export function first_day_of_quarter(date) {
  return dayjs(date).startOf("quarter").toDate();
}
export function first_day_of_fiscal_quarter(date) {
  date = first_day_of_month(date);
  const zero_based_fiscal_year_start = getLocale().fiscal_year_start - 1;
  date.setMonth(date.getMonth() - zero_based_fiscal_year_start);
  const quarter = Math.floor(date.getMonth() / 3);
  date.setMonth(zero_based_fiscal_year_start + quarter * 3);
  return date;
}
export function first_day_of_fiscal_year(date) {
  date = dst_safe_date(date);
  const zero_based_fiscal_year_start = getLocale().fiscal_year_start - 1;
  date.setDate(1);
  if (date.getMonth() < zero_based_fiscal_year_start) {
    date.setFullYear(date.getFullYear() - 1);
  }
  date.setMonth(zero_based_fiscal_year_start);
  return date;
}
export function first_day_of_year(date) {
  date = dst_safe_date(date);
  date.setMonth(0);
  date.setDate(1);
  return date;
}
export function last_day_of_fiscal_year(date) {
  date = first_day_of_fiscal_year(date);
  date.setYear(date.getFullYear() + 1);
  date.setDate(0);
  return date;
}
export function days_in_week_for(day, date_format) {
  let d, j;
  const first_day_of_week2 = first_day_of_week2(day);
  const results = [];
  for (d = j = 0; j <= 6; d = ++j) {
    const date = dst_safe_date(first_day_of_week2);
    date.setDate(date.getDate() + d);
    if (date_format) {
      results.push(format(date, date_format));
    } else {
      results.push(date);
    }
  }
  return results;
}
export function is_this_week(date) {
  return first_day_of_week(date).getTime() === first_day_of_week().getTime();
}
export function is_this_semimonth(date) {
  return first_day_of_semimonth(date).getTime() === first_day_of_semimonth().getTime();
}
export function is_this_month(date) {
  return is_this_year(date) && date.getMonth() === new Date().getMonth();
}
export function is_this_quarter(date) {
  return is_this_year(date) && Math.floor(date.getMonth() / 3) === Math.floor(new Date().getMonth() / 3);
}
export function is_this_fiscal_year(date) {
  return first_day_of_fiscal_year(date).getTime() === first_day_of_fiscal_year().getTime();
}
export function is_this_year(date) {
  return date.getFullYear() === new Date().getFullYear();
}
export function format(date, format2) {
  if (date == null) {
    return "";
  }
  date = dayjs(date);
  switch (format2) {
    case "iso":
      return date.format("YYYY[-]MM[-]DD");
    case "human_format":
      return date.format("DD[ ]MMM[ ]YYYY");
    case "day_month":
      return date.format("DD[ ]MMM");
    case "day_of_week":
      return date.format("dddd");
    case "day_of_week_short":
      return date.format("ddd");
    case "year":
      return date.format("YYYY");
    case "month":
      return date.format("MM");
    case "month_year":
      return date.format("MMM[ ]YYYY");
    case "day":
      return date.format("DD");
    case "day_of_year":
      return `${date.dayOfYear()}`;
    case "account_format":
      return localize(date);
    default:
      return date.toString();
  }
}
export function parse_ruby_date_str(s) {
  if (s == null) {
    return null;
  }
  const [date] = s.split("T");
  const [year, month, day] = date.split("-");
  return new Date(+year, +month - 1, +day, 12);
}
export function gmt_timezone_offset_at_start_of_year(date = new Date()) {
  const start_of_year = new Date(date.getFullYear(), 0, 1, 12, 0, 0, 0);
  const minutes_ahead_of_gmt = start_of_year.getTimezoneOffset();
  return minutes_ahead_of_gmt / 60 * -1;
}
export function dst_safe_date(date = new Date()) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 12);
}
export function apply_date_offset(date, offset) {
  date = new Date(date.getTime());
  date.setDate(date.getDate() + offset);
  return date;
}
export function timeframeBounds(timeframe, start) {
  let from;
  let to;
  start = dayjs(start);
  switch (timeframe) {
    case "year":
      from = dayjs(first_day_of_fiscal_year(start.toDate()));
      to = from.add(11, "months").endOf("month");
      break;
    case "quarter":
      from = dayjs(first_day_of_fiscal_quarter(start.toDate()));
      to = from.add(2, "months").endOf("month");
      break;
    default:
      from = start.startOf(timeframe);
      to = from.endOf(timeframe);
      break;
  }
  const now = dayjs();
  const current = !now.isBefore(from) && !now.isAfter(to);
  return { current, from, to };
}
